import { useEffect } from 'react';
import { useEditor } from '@tiptap/react';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import TipTapText from '@tiptap/extension-text';
import Placeholder from '@tiptap/extension-placeholder';
import Mention from '@tiptap/extension-mention';
import HardBreak from '@tiptap/extension-hard-break';
import History from '@tiptap/extension-history';
import Editor from '@/components/editor/Editor';
import suggestion from './suggestion';
import debounce from 'lodash/debounce';
import { CustomKeyMap } from './cutom-key-map-extension';
import { ConvertNewLineOnPaste } from '@/ui/editor/extensions/new-line-to-br';

export const NotesEditor = ({
  onUpdate = () => {},
  onEnter = () => {},
  isEnterPressed,
  height = '200px',
  defaultValue = '',
  isUpdate = false,
  setInitialFocus = false,
}) => {
  const editor = useEditor({
    extensions: [
      Document,
      Paragraph,
      TipTapText,
      HardBreak,
      History,
      Mention.configure({
        HTMLAttributes: { class: 'mention' },
        // While extending for otheres we can pass the url to fetch and process data later
        suggestion: suggestion(),
      }),
      Placeholder.configure({
        placeholder: 'Write a note and hit enter to submit',
      }),
      CustomKeyMap.configure({ customEnterFunction: onEnter }),
      ConvertNewLineOnPaste,
    ],
    onUpdate: debounce(({ editor }) => {
      onUpdate(editor?.getHTML());
    }, 300),
    onCreate: ({ editor }) => {
      editor.commands.setContent(defaultValue);
    },
  });

  useEffect(() => {
    if (!editor) return;
    if (setInitialFocus) editor.commands.focus();
  }, [editor]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!editor || !isEnterPressed || isUpdate) return;
    editor?.commands?.setContent('');
  }, [editor, isEnterPressed]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Editor
      editor={editor}
      height={height}
      wrapperProps={{
        padding: '0px',
        className: 'notes-editor',
      }}
    />
  );
};
